import { render, staticRenderFns } from "./give-proudly-ForgotPasswordEmail.vue?vue&type=template&id=565fa12e&scoped=true"
import script from "./give-proudly-ForgotPasswordEmail.vue?vue&type=script&lang=js"
export * from "./give-proudly-ForgotPasswordEmail.vue?vue&type=script&lang=js"
import style0 from "./give-proudly-ForgotPasswordEmail.vue?vue&type=style&index=0&id=565fa12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565fa12e",
  null
  
)

export default component.exports